export default __webpack_public_path__ + "static/media/March_01.6f807d6a.png";